import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

export type Tone = 'neutral' | 'brand' | 'success' | 'warning' | 'danger' | 'info';

const tones: Record<Tone, string> = {
  neutral: 'bg-surface-hover text-ink-muted',
  brand: 'bg-brand-soft text-brand-ink',
  success: 'bg-success-soft text-success',
  warning: 'bg-warning-soft text-warning',
  danger: 'bg-danger-soft text-danger',
  info: 'bg-info-soft text-info',
};

export function Badge({ tone = 'neutral', children, className, dot }: { tone?: Tone; children: ReactNode; className?: string; dot?: boolean }) {
  return (
    <span className={cn('inline-flex items-center gap-1.5 whitespace-nowrap rounded-md px-2 py-0.5 text-xs font-medium', tones[tone], className)}>
      {dot && <span className="h-1.5 w-1.5 rounded-full bg-current" aria-hidden />}
      {children}
    </span>
  );
}

export const PRIORITY_TONE: Record<string, Tone> = { low: 'neutral', medium: 'info', high: 'warning', urgent: 'danger' };
export const TASK_STATUS_TONE: Record<string, Tone> = { todo: 'neutral', in_progress: 'info', in_review: 'warning', blocked: 'danger', done: 'success', cancelled: 'neutral' };
export const TEMPERATURE_TONE: Record<string, Tone> = { hot: 'danger', warm: 'warning', cold: 'info' };
export const LEAD_STATUS_TONE: Record<string, Tone> = { open: 'brand', won: 'success', lost: 'danger' };
export const EMPLOYEE_STATUS_TONE: Record<string, Tone> = { active: 'success', probation: 'info', notice: 'warning', resigned: 'neutral', terminated: 'danger', inactive: 'neutral' };
export const SESSION_STATE_TONE: Record<string, Tone> = { active: 'success', idle: 'warning', on_break: 'info', ended: 'neutral' };
